import BookIndex from "components/shared/book/list";
import List from "components/shared/list";
import { paths } from "helpers/paths";
import { tableContainer } from "helpers/redux";
import React from "react";

class Dictionaries extends BookIndex {
    thead = () => {
        return (
            <thead>
                <tr>
                    <th>ID</th>
                    <th>Название</th>
                    <th className="text-center">Количество</th>
                </tr>
            </thead>
        );
    };

    renderCounter = () => {
        const { count } = this.props;
        return (
            <>
                &nbsp;
                <small>
                    (Отображены&nbsp;
                    <strong>1-{count}</strong>
                    &nbsp;из <strong>{count}</strong>)
                </small>
            </>
        );
    };

    renderListComponent = () => {
        const { isTable } = this.props;
        return (
            <List
                {...this.props}
                items={[
                    ...this.props.items,
                    { type: "distributionBidSources", displayName: "Источники внешних заказов" },
                ]}
                isTable={!!isTable}
                renderRow={this.renderTableRow}
                renderHead={this.thead}
            />
        );
    };

    renderTableRow = (item) => {
        return (
            <tr
                key={item.id}
                onClick={() =>
                    this.props.history.push(
                        item.type === "distributionBidSources"
                            ? paths.distributionBidSources
                            : paths.dictionariesShow(item.id),
                    )
                }
            >
                <td>{item.id || "-"} </td>
                <td>{item.displayName}</td>
                <td className="text-center">{item.items ? item.items.length : ""}</td>
            </tr>
        );
    };
}

export default tableContainer(Dictionaries, "dictionaries");
